import React from 'react';
// @mui
import {Button, Grid} from '@mui/material';
// components
import RTextField from '../../componentes/forms/inputs/RTextField';
import RSelect from '../../componentes/forms/inputs/RSelect';

// ----------------------------------------------------------------------

export default function FiltroForm({ actualizaCampo, busqueda, provincias, tipos, oficinas, actualiza, resetFiltro }) {
  return (
    <form style={{ width: '100%'}}>
      <Grid container spacing={1} sx={{ marginBottom: '30px' }}>
        <RSelect name="oficina" label="Oficina" actualizaCampo={actualizaCampo} value={busqueda.oficina} md={3}
          values={oficinas}
        />
        <RTextField type="text" name="texto" label="Texto" actualizaCampo={actualizaCampo} value={busqueda.texto} md={2} />
        <RSelect name="provincia" label="Provincia*" actualizaCampo={actualizaCampo} value={busqueda.provincia} md={2}
          values={provincias}
        />
        <RSelect name="estado" label="Estado" actualizaCampo={actualizaCampo} value={busqueda.estado} md={2}
          values={[{id:'Finalizado', nombre: 'Finalizado'},{id:'En Proceso', nombre: 'En Proceso'},{id:'Por empezar', nombre: 'Por empezar'}]}
        />
          {/* <RSelect name="tipo" label="Tipo Busqueda" actualizaCampo={actualizaCampo} value={busqueda.tipo} md={2}
          values={tipos}
        /> */}
        <Grid item md={1}>
          <Button variant="contained" color="warning" sx={{ color: 'white', marginLeft: '15px'}} to="#"
                                onClick={()=>actualiza()}>
                                  Filtrar
                                </Button>
        </Grid>
        <Grid item md={2}>
          <Button variant="contained" color="error" sx={{ color: 'white', marginLeft: '15px'}} to="#"
                                onClick={()=>resetFiltro()}>
                                  Borrar Filtro
                                </Button>
        </Grid>
      </Grid>
    </form>
  );
}
